import React, {useEffect} from "react";
import {useTranslation} from "next-i18next";
import SimpleCard from "@/base/components/dashboard/SimpleCart";
import ClockCircleFilled from "@ant-design/icons/ClockCircleFilled";
import useFNSLocale from "@/base/utils/datefnslocale";
import {format} from "date-fns/format";
import Link from "next/link";
import {getPagesList} from "@/base/pages/p/[...slug]";
import {CustomPageSimple} from "@/base/types/CustomPageSimple";
import {withCache} from "@/base/utils/cache";
import {useRouter} from "next/router";
import {LImage} from "@/base/components/LImage";

export default function NewsBoard() {
	const {t} = useTranslation();
	const fnsLocale = useFNSLocale();
	const router = useRouter();

	const [pages, setPages] = React.useState<CustomPageSimple[]>([]);

	useEffect(() => {
		withCache(
			"sp_latest_news",
			60 * 20 * 1000,
			async () => {
				return await getPagesList(router.locale || 'en', process.env.NEXT_PUBLIC_PAGE_SITE || undefined, 'news', 3);
			},
			true
		).then((pages) => {
			setPages(pages || []);
		}).catch((e) => {
			console.error(e);
			setPages([]);
		});
	}, []);

	// TODO: page additional links
	return <SimpleCard
		headerClassName={`bg-primary-50`}
		title={t(`base-dashboard:news.title`)}
		bodyClassName={` gap-8 flex flex-col`}
	>
		{/*TODO: make function get page url full*/}
		{pages.map((page, index, full) => {
			return <Link key={index} href={`/${page.url}`}>
				<div className={`flex gap-6 opacity-70 hover:opacity-100 transition-opacity duration-200 flex-wrap`}>
					{page.image_url && (
						<div className={`flex items-start justify-center w-1/3 flex-none`}>
							<LImage
								src={page.image_url || `/base/image/api-screenshot.webp`}
								width={500 / 1.3}
								height={329 / 1.3}
								layout={'responsive'}
								className={`object-contain shadow shadow-lg rounded-2xl overflow-hidden`}
								alt={t(`base-common:header.items.api`)}
							/>
						</div>
					)}
					<div className={`gap-6 flex flex-col justify-center`}>
						<div className={`flex flex-col gap-2.5`}>
							<p className={`text-lg font-montserrat-alternates !text-text-2 font-medium`}>{page.title}</p>
							<p className={`text-color`}>{page.description}</p>
							<span className={``}>
						<Link href={`/${page.url}`}>{t(`base-common:words.read-full`)}</Link>
								{/*● <Link href={`/dashboard/api`}>{t(`base-common:header.items.api-keys`)}</Link>*/}
					</span>
							{/*<hr className={`mt-0 opacity-20`}/>*/}
							<p className={`text-sm opacity-70 text-color`}><ClockCircleFilled/> {format(new Date(page.created_at), 'dd MMMM yyyy HH:mm', {locale: fnsLocale})}</p>
						</div>
					</div>
				</div>
				{full.length - 1 !== index && <hr className={`mt-6 opacity-20`}/>}
			</Link>
		})}
	</SimpleCard>
}